<script setup lang="ts">
import { onUnmounted } from 'vue'
import { useAiChatStore } from '@/stores/ai-chat'
import { useAppLayout } from '@/composables/useAppLayout'
import AiSidebarPanel from './AiSidebarPanel.vue'
import { Sheet, SheetContent } from '@kyoto2/components/ui/sheet'

const store = useAiChatStore()
const { isDesktop } = useAppLayout()

let activeOnMove: ((ev: MouseEvent) => void) | null = null
let activeOnUp: (() => void) | null = null

onUnmounted(() => {
  if (activeOnMove) window.removeEventListener('mousemove', activeOnMove)
  if (activeOnUp) window.removeEventListener('mouseup', activeOnUp)
})

function onResizeStart(e: MouseEvent) {
  const startX = e.clientX
  const startW = store.sidebarWidth

  function onMove(ev: MouseEvent) {
    store.setSidebarWidth(startW + (startX - ev.clientX))
  }
  function onUp() {
    window.removeEventListener('mousemove', onMove)
    window.removeEventListener('mouseup', onUp)
    activeOnMove = null
    activeOnUp = null
  }
  activeOnMove = onMove
  activeOnUp = onUp
  window.addEventListener('mousemove', onMove)
  window.addEventListener('mouseup', onUp)
}

function onMobileOpenChange(open: boolean) {
  if (!open) store.toggleSidebar(false)
}
</script>

<template>
  <aside
    v-if="isDesktop"
    v-show="store.sidebarOpen"
    class="relative hidden lg:flex flex-col h-full shrink-0 min-w-0 border-l border-border bg-background overflow-hidden"
    :style="{ width: `${store.sidebarWidth}px` }"
  >
    <div
      class="absolute left-0 top-0 bottom-0 w-1 cursor-col-resize hover:bg-primary/20 z-10"
      @mousedown="onResizeStart"
    />
    <AiSidebarPanel />
  </aside>

  <Sheet v-if="!isDesktop" :open="store.sidebarOpen" @update:open="onMobileOpenChange">
    <SheetContent
      side="right"
      class="w-full max-w-none sm:max-w-none p-0 gap-0 flex flex-col h-full [&>button]:hidden"
    >
      <AiSidebarPanel />
    </SheetContent>
  </Sheet>
</template>
